export const MIN_WEIGHT = 3;

export const MAX_WEIGHT = 180;

export const WEIGHT_ERROR = `Ollie is currently available only to pups between ${MIN_WEIGHT} and ${MAX_WEIGHT} pounds`;

export const WEIGHT_FORMAT_ERROR = `Please use a whole number for pup weight`;
